import { render, staticRenderFns } from "./ProjectItemStatusAuditLogsTable.vue?vue&type=template&id=52518b36&scoped=true&"
import script from "./ProjectItemStatusAuditLogsTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectItemStatusAuditLogsTable.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectItemStatusAuditLogsTable.vue?vue&type=style&index=0&id=52518b36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52518b36",
  null
  
)

export default component.exports